import { useEffect } from "react";

import { AssessoresHeader } from "@/components/assessores/AssessoresHeader";
import { AssessoresHero } from "@/components/assessores/AssessoresHero";
import { AssessoresParaQuemE } from "@/components/assessores/AssessoresParaQuemE";
import { AssessoresDiferenciais } from "@/components/assessores/AssessoresDiferenciais";
import { AssessoresComoFunciona } from "@/components/assessores/AssessoresComoFunciona";
import { AssessoresComoGeraReceita } from "@/components/assessores/AssessoresComoGeraReceita";
import { AssessoresStats } from "@/components/assessores/AssessoresStats";
import { AssessoresFormSection } from "@/components/assessores/AssessoresFormSection";
import { AssessoresCTAFinal } from "@/components/assessores/AssessoresCTAFinal";
import { ParceirosV2DepoimentosAssessor } from "@/components/parceiros-v2/ParceirosV2DepoimentosAssessor";
import { ParceirosV2FAQ } from "@/components/parceiros-v2/ParceirosV2FAQ";
import { ParceirosV2Footer } from "@/components/parceiros-v2/ParceirosV2Footer";
import { ParceirosV2StickyCTA } from "@/components/parceiros-v2/ParceirosV2StickyCTA";
import { useMetaPixel } from "@/hooks/useMetaPixel";

const PAGE_TITLE = "Seja Assessor Parceiro — Allu Invest";
const PAGE_DESC =
  "Construa receita recorrente divulgando crédito estruturado com lastro real, mantendo sua independência. Programa de parceiros da Allu Invest para consultores, assessores autônomos e educadores financeiros.";

const Assessores = () => {
  useMetaPixel();

  useEffect(() => {
    const prevTitle = document.title;
    document.title = PAGE_TITLE;

    const metaDesc = document.querySelector('meta[name="description"]');
    const prevDesc = metaDesc?.getAttribute("content") ?? "";
    metaDesc?.setAttribute("content", PAGE_DESC);

    const prevBodyBg = document.body.style.backgroundColor;
    const prevBodyFont = document.body.style.fontFamily;
    document.body.style.backgroundColor = "#FAF8F5";
    document.body.style.color = "#112711";
    document.body.style.fontFamily =
      '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif';

    return () => {
      document.title = prevTitle;
      metaDesc?.setAttribute("content", prevDesc);
      document.body.style.backgroundColor = prevBodyBg;
      document.body.style.color = "";
      document.body.style.fontFamily = prevBodyFont;
    };
  }, []);

  return (
    <div
      className="min-h-screen bg-[#FAF8F5] text-[#323F4F]"
      style={{
        fontFamily:
          '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif',
      }}
    >
      <AssessoresHeader />
      <main>
        <AssessoresHero />
        <AssessoresParaQuemE />
        <AssessoresDiferenciais />
        <AssessoresComoFunciona />
        <AssessoresComoGeraReceita />
        <AssessoresStats />
        <ParceirosV2DepoimentosAssessor />
        <ParceirosV2FAQ />
        <AssessoresFormSection />
        <AssessoresCTAFinal />
      </main>
      <ParceirosV2Footer />
      <ParceirosV2StickyCTA />
    </div>
  );
};

export default Assessores;
